import { LoginUsecase, type LogoutReason } from './Login'

export class LogoutUsecase extends LoginUsecase {
    /**
     * Logs user out and reloads page
     */
    override logout (logoutReason: LogoutReason): void {
        super.logout(logoutReason)
    }
}
